const paymentMethods = [
  'Cash',
  'StoreCash',
  'StoreCard',
  'PartnerCredit',
  'DriverCash',
  'AutoConfirmed',
  'Card',
  'Fawry',
  'Aman',
  'Wallet',
  'Agent',
  'Link',
  'Orange',
];
const Agents = ['ahly momkn', 'sadad', 'ekhales'];

export { paymentMethods, Agents };
